/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertMemoriesApp} from '../api'

export const useMutationUpsertMemoriesApp = createReactQueryMutationHook('upsertMemoriesApp', upsertMemoriesApp)
